import _toConsumableArray from 'babel-runtime/helpers/toConsumableArray';
import _typeof from 'babel-runtime/helpers/typeof';

/*
  messages.js
  ------------------------------------------------------------

  Generic message management
*/

var ADD = 'store/messages/ADD';
var CLOSE = 'store/messages/CLOSE';
var CLOSE_NEWEST = 'store/messages/CLOSE_NEWEST';
var CLOSE_ALL = 'store/messages/CLOSE_ALL';

var initialState = [];

var counter = 0;

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  counter++;
  var id = counter;

  if (action.error && action.payload && _typeof(action.payload) === 'object' && action.payload.hasOwnProperty('errorCode')) {
    return [{
      id: id,
      status: 'error',
      code: action.payload.errorCode
    }].concat(_toConsumableArray(state));
  }

  switch (action.type) {
    case ADD:
      return [{
        id: id,
        status: action.status,
        message: action.message,
        code: action.code
      }].concat(_toConsumableArray(state));

    case CLOSE:
      return state.filter(function (message) {
        return message.id !== action.id;
      });

    case CLOSE_NEWEST:
      return state.slice(0, -1);

    case CLOSE_ALL:
      return initialState;

    default:
      return state;
  }
}

var close = function close(id) {
  return {
    type: CLOSE,
    id: id
  };
};

var addStatus = function addStatus(status, code) {
  return {
    type: ADD,
    status: status,
    code: code
  };
};

var addMessage = function addMessage(status, message) {
  return {
    type: ADD,
    status: status,
    message: message
  };
};

var closeNewest = function closeNewest() {
  return {
    type: CLOSE_NEWEST
  };
};

var closeAll = function closeAll() {
  return {
    type: CLOSE_ALL
  };
};

export { ADD, CLOSE, CLOSE_NEWEST, CLOSE_ALL, close, addStatus, addMessage, closeNewest, closeAll };
export default reducer;
